@for (group of formGroups; track group; let i = $index) {
  <div [formGroup]="group" class="border pt-4 rounded mb-4">
    <!-- Grid layout to match form structure -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
      <!-- Modulo -->
      <div class="relative">
        <siat-select-field
          [formGroup]="group"
          controlName="moduli"
          id="id"
          name="name"
          label="{{ 'SANITARIO.moduloLabel' | translate }}"
          placeholder="{{ 'SANITARIO.moduloPlaceholder' | translate }}"
          [items]="moduli()"
          class="w-full"
        ></siat-select-field>
        @if (isLoadingModuli()) {
          <div class="absolute top-1/2 right-3 transform -translate-y-1/2">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        }
        @if (!readonly) {
          <button type="button" class="bg-transparent border-none p-0 cursor-pointer text-xs mt-1" style="color: #95254f" [class.invisible]="!group.get('moduli')?.value" (click)="clearModuliRow(i)">
            Svuota
          </button>
        }
      </div>
      <!-- Lavoro -->
      <div>
        <siat-select-field
          [formGroup]="group"
          controlName="lavori"
          id="id"
          name="name"
          label="{{ 'SANITARIO.lavoroLabel' | translate }}"
          placeholder="{{ 'SANITARIO.lavoroPlaceholder' | translate }}"
          [items]="getLavoriForGroup(i)"
          class="w-full"
        ></siat-select-field>
        @if (!readonly) {
          <button type="button" class="bg-transparent border-none p-0 cursor-pointer text-xs mt-1" style="color: #95254f" [class.invisible]="!group.get('lavori')?.value" (click)="clearLavoriRow(i)">
            Svuota
          </button>
        }
      </div>
    </div>
    <!-- Pulsanti azione -->
    @if (!readonly) {
      <div class="flex gap-2 items-center justify-end px-4 pb-4 pt-2">
        <button
          mat-mini-fab
          (click)="addEntry()"
          [disabled]="shouldDisableAddButton(i)"
          [attr.aria-label]="'SANITARIO.aggiungiLabel' | translate"
          style="border: 2px solid var(--mat-sys-primary) !important; border-radius: 30% !important; background-color: white !important;"
          class="hover:bg-pink-50!"
          >
          <mat-icon style="color: var(--mat-sys-primary) !important;">add</mat-icon>
        </button>
        <button
          mat-mini-fab
          (click)="removeEntry(i)"
          [attr.aria-label]="'SANITARIO.rimuoviLabel' | translate"
          style="border: 2px solid var(--mat-sys-primary) !important; border-radius: 30% !important; background-color: white !important;"
          class="hover:bg-pink-50!"
          >
          <mat-icon style="color: var(--mat-sys-primary) !important;">delete</mat-icon>
        </button>
      </div>
    }
  </div>
}
